import { Injectable } from '@angular/core';

@Injectable()
export class FormioAppConfig {
  appUrl = 'http://localhost:1234/who/knows';
  apiUrl = 'http://localhost:1234/why/knows/?=';
  icons?: string;
  formOnly?: boolean;
}
